import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit,AfterViewInit {

  @Input() sidenavToggleState :any;
  @ViewChild('drawer') private drawerRef: any;
  

  showSidenav = false;
  sidenavElements=[]
  iconsArr=[]

  constructor(public router : Router) { }

  ngOnInit(): void {

  }
ngAfterViewInit() : void {
  this.sidenavToggleFn()

}
  sidenavToggleFn(){
    this.showSidenav = !this.showSidenav
    this.drawerRef.toggle();
  }

  goToElement(event:any){
    console.log(event);
   
  }



}